import { ref } from 'vue';
const makes = ref([]);
const selectedMake = ref(null);
const makeSearchQuery = ref('');
const models = ref([]);
const selectedModel = ref(null);
const modelSearchQuery = ref('');
const selectedYearFilter = ref('after-1994');
const showAllMakes = ref(false);
const visibleMakesLimit = ref(42); // Default: 7 columns × 6 rows
export function useMakeModelSearch() {
    function clearAllMakeModelSearchData() {
        makes.value = [];
        selectedMake.value = null;
        makeSearchQuery.value = '';
        models.value = [];
        selectedModel.value = null;
        modelSearchQuery.value = '';
        selectedYearFilter.value = 'after-1994';
        showAllMakes.value = false;
        visibleMakesLimit.value = 42;
    }
    return {
        makes,
        selectedMake,
        makeSearchQuery,
        models,
        selectedModel,
        modelSearchQuery,
        selectedYearFilter,
        showAllMakes,
        visibleMakesLimit,
        clearAllMakeModelSearchData
    };
}
